import axios from 'axios';
import { getApiUrl } from '../lib/api-url';

export interface Review {
    id: string;
    user: string;
    rating: number;
    comment: string;
    date: string;
    verified: boolean;
    isActive: boolean;
    source?: string;
    externalId?: string | null;
    createdAt: string;
    updatedAt: string;
}

export type LiveGoogleReview = {
    id: string;
    user: string;
    rating: number;
    comment: string;
    date: string;
};

export const reviewsService = {
    async getPublic() {
        const response = await axios.get<Review[]>(`${getApiUrl()}/reviews`);
        return response.data;
    },

    async getGoogleLive() {
        const response = await axios.get<LiveGoogleReview[]>(`${getApiUrl()}/reviews/google/live`);
        return response.data;
    },

    async submit(data: { user: string; rating: number; comment: string }) {
        const response = await axios.post<Review>(`${getApiUrl()}/reviews/submit`, data);
        return response.data;
    },
};
